import type { OnboardingProfileEnvelope } from '@onflow/shared';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { api, refreshAccessToken } from '../lib/api.js';

export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      const token = await refreshAccessToken();
      if (!token) {
        setError('Sign-in failed. Please try again.');
        return;
      }

      // Fast-path brand-new users straight to onboarding. Partially-set-up
      // users land on /dashboard and the RequireSetupComplete gate bounces
      // them to the first missing step (routine select / diet preferences
      // / diet select). On probe failure (AI_COACH disabled, transient
      // 5xx) we fall through to /dashboard for the same reason.
      try {
        const { profile } = await api<OnboardingProfileEnvelope>('/onboarding');
        if (!profile?.completedAt) {
          navigate('/onboarding/mode', { replace: true });
          return;
        }
      } catch {
        // Intentional fallthrough — the gate on /dashboard will route.
      }
      navigate('/dashboard', { replace: true });
    })();
  }, [navigate]);

  return (
    <div className="splash">
      {error ? (
        <div role="alert">
          <p>{error}</p>
          <button onClick={() => navigate('/login', { replace: true })}>Back to sign-in</button>
        </div>
      ) : (
        <span>Completing sign-in…</span>
      )}
    </div>
  );
}
